var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.218 2.50002L21.901 8.18202V16.218L16.218 21.901H8.18202L2.49902 16.218V8.18202L8.18202 2.49902H16.218V2.50002ZM11 15V17H13V15H11ZM11 7.00002V13H13V7.00002H11Z",
    fill: "currentColor"
  })));
};
export default SvgWarning;